import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NavigationProgressComponent} from './shared/ui/navigation-progress/navigation-progress.component';
import {VersionCheckService} from './services/version-check.service';
import {SecurityVerificationService} from './shared/security-verification/security-verification.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavigationProgressComponent, NzModalModule],
  providers: [VersionCheckService, SecurityVerificationService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly versionCheckService = inject(VersionCheckService);

  ngOnInit(): void {
    this.versionCheckService.start();
  }
}
